import { Component, OnInit, Inject } from '@angular/core';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';

@Component({
  selector: 'app-configuracion',
  templateUrl: './configuracion.component.html',
  styleUrls: ['./configuracion.component.css']
})
export class ConfiguracionComponent implements OnInit {

  constructor(
    private router: Router,
    @Inject(SESSION_STORAGE) private storage: StorageService,
  ) { }

  ngOnInit(): void {
    if (this.storage.get("idConexion")==undefined){
      this.router.navigate(['/']);
      return;
    }
  }

  mostrarConsorcios(){
    this.router.navigate(['/consorcios'])
  }





  mostrarCasillasMails(){
    this.router.navigate(['/casillasMails'])
  }

  mostrarTiposDocumento(){
    this.router.navigate(['/tiposDocumento'])
  }

  mostrarTiposDomicilio(){
    this.router.navigate(['/tiposDomicilio'])
  }

  mostrarTiposMails(){
    this.router.navigate(['/tiposMails'])
  }

  mostrarTiposSexo(){
    this.router.navigate(['/tiposSexo'])
  }

  mostrarObrasSociales(){
    this.router.navigate(['/obrasSociales'])
  }

  mostrarProvincias(){
    this.router.navigate(['/provincias'])
  }

  mostrarLocalidad(){
    this.router.navigate(['/localidades'])
  }

  mostrarTiposTelefono(){
    this.router.navigate(['/tiposTelefonos'])
  }

  mostrarPrestaciones(){
    this.router.navigate(['/prestaciones'])
  }
}
